import { makeAutoObservable } from "mobx";

import { i18n } from "i18next";

import { IAccountWrapper } from "../../utils/MsGraphApiCall";
import { AppLanguageOptions } from "../models/constants/app-language-options.const";
import { ILanguageOption } from "../models/interfaces";

export class UserStore {
  public UserImage: string = "icons/user.svg";

  private user?: IAccountWrapper;
  private _currentLanguage: ILanguageOption = AppLanguageOptions[0];
  private i18n: i18n | undefined;
  private _accessToken: string = "";

  private acceptedTermsOfUseAndPrivacyPolicy: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get currentLanguage(): ILanguageOption {
    return this._currentLanguage;
  }

  public set currentLanguage(language: ILanguageOption) {
    this._currentLanguage = language;
  }

  public setAccessToken = (accessToken: string) => {
    this._accessToken = accessToken;
  };

  public get userAccessToken(): string {
    return this._accessToken;
  }

  public get i18nInstance(): i18n | undefined {
    return this.i18n;
  }

  public findLanguageOptionByCode(code: string): ILanguageOption | undefined {
    return AppLanguageOptions.find(option => option.code === code);
  }

  public setLanguageLibrary = (i18n: i18n) => {
    this.i18n = i18n;
  };

  changeLanguage(languageOption: ILanguageOption) {
    this.currentLanguage = languageOption;

    if (this.i18n && this.i18n.language != languageOption.code) {
      this.i18n.changeLanguage(languageOption.code);
    }
  }

  public get userInfo(): IAccountWrapper | undefined {
    return this.user;
  }

  setUserInfo = async (user: IAccountWrapper) => {
    this.user = user;
  };

  public get userAcceptedTermsOfUseAndPrivacyPolicy(): boolean {
    return this.acceptedTermsOfUseAndPrivacyPolicy;
  }

  public setUserAcceptedTermsOfUseAndPrivacyPolicy(value: boolean) {
    this.acceptedTermsOfUseAndPrivacyPolicy = value;
  }
}
